import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';

// Benign browser notice (Google Maps, extensions) that CRA's dev overlay shows as a crash.
// Capture phase runs before the overlay's own window listener.
if (process.env.NODE_ENV === 'development') {
  window.addEventListener('error', (e) => {
    if (/^ResizeObserver loop/.test(e.message || '')) e.stopImmediatePropagation();
  }, true);
}

const root = ReactDOM.createRoot(document.getElementById('root'));

// Auth0 returns to the origin, so restore the page the customer signed in from (and
// drop ?code=&state=). replaceState alone won't re-render the router, hence popstate.
const onRedirectCallback = (appState) => {
  window.history.replaceState({}, '', appState?.returnTo || '/');
  window.dispatchEvent(new PopStateEvent('popstate'));
};

root.render(
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_DOMAIN}
    clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
    authorizationParams={{
      redirect_uri: process.env.REACT_APP_AUTH0_CALLBACK_URL,
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      scope: 'openid profile email offline_access'
    }}
    cacheLocation="localstorage"
    useRefreshTokens={true}
    skipRedirectCallback={false}
    onRedirectCallback={onRedirectCallback}
  >
    <App />
  </Auth0Provider>
);

reportWebVitals();